import React from "react";
import AppSwitch from "@Components/AppSwitch";
import Header from "@Components/Header";
import getSubdomain from "@Helpers/GetSubdomain";
import TenderEditLocalStorage from "@SmartComponents/TenderEdit/LocalStorage";
class RegisterForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectTo: "",
            subdomain: undefined,
        };
    }
    componentDidMount() {
        const subdomain = getSubdomain();
        switch (subdomain) {
            case "era":
            case "7ss":
                this.setState({
                    redirectTo: "auth/login",
                });
                break;
            //add white labels here
            case "chambercompare":
                this.setState({
                    subdomain,
                });
        }
    }
    render() {
        if (this.state.redirectTo !== "") {
            return React.createElement(AppSwitch, { uri: this.state.redirectTo });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null,
                "Welcome to ",
                React.createElement("b", null, "\u00A0Predict"),
                ", the Comparison Platform for Business Mobile"),
            React.createElement(TenderEditLocalStorage, { loaded: this.props.loaded })));
    }
}
export default RegisterForm;
